<template>
  <v-layout>
    <v-flex xs12>
      <v-card class="mt-2" width="100%">

        <div>
          <v-alert v-model="userDeletedSucc" dismissible type="success">
            User Deleted Successfully
          </v-alert>
          <v-alert v-model="userDeletedFail" dismissible type="error">
            Failed to delete user. Please contact support.
          </v-alert>
        </div>

        <v-card-title>
          <v-dialog v-model="dialog" max-width="500px">
            <v-btn color="primary" dark slot="activator" class="mb-2">New User</v-btn>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
                <v-spacer></v-spacer>
                <v-btn v-if="this.editedIndex > -1" :loading="emailSending" @click="sendResetEmail()">
                  Send Reset Email
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-form ref="newUser" v-model="newUserValid">
                        <v-text-field label="Full Name" v-model="editedItem.Name"
                          :rules="[(v) => !!v || 'Name is required']" required></v-text-field>
                        <v-text-field label="Email" v-model="editedItem.Email" :rules="[
            (v) => !!v || 'Email is required',
            (v) =>
              /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                v
              ) || 'E-mail must be valid',
          ]" required :append-icon="this.editedIndex > -1 ? 'lock' : ''"
                          :readonly="this.editedIndex > -1"></v-text-field>
                        <v-text-field v-if="this.editedIndex < 0" label="Password" v-model="password" type="password"
                          :rules="[
            (v) => !!v || 'Password is required',
            (v) =>
              v.length > 6 ||
              'Password must be at least 6 characters',
          ]" required></v-text-field>
                        <v-select label="Select Role" :items="roles" v-model="editedItem.Role">
                        </v-select>
                        <v-select label="Minumum Job Status that can be invoiced" :items="[
            { text: 'Completed', value: 2 },
            { text: 'Cubo Approved', value: 3 },
          ]" v-model="editedItem.minInvoiceStatus" v-if="editedItem.Role === 'Supplier'">
                        </v-select>
                        <v-select label="Select Supplier" :items="suppliers" v-model="editedItem.Company"
                          item-text="name" item-value="key">
                        </v-select>
                        <v-autocomplete ref="customerSelect" label="Select Company" :items="customers"
                          v-model="editedItem.Customers" item-text="customerName" item-value="id"
                          placeholder="Leave blank to select all" chips multiple>
                          <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index < 5">
                              <span>{{ item.customerName }}</span>
                            </v-chip>
                            <span v-if="index === 5" class="text-grey text-caption align-self-center">
                              (+{{ editedItem.Customers.length - 5 }} others)
                            </span>
                          </template>
                        </v-autocomplete>
                        <v-checkbox v-if="[
            'Engineer',
            'Supplier',
            'Support and Engineer',
            'Admin and Engineer',
          ].indexOf(editedItem.Role) !== -1
            " v-model="editedItem.unassigned" label="Access to unassigned jobs"></v-checkbox>
                        <v-checkbox v-if="[
            'Engineer',
            'Supplier',
            'Support and Engineer',
            'Admin and Engineer',
          ].indexOf(editedItem.Role) !== -1
            " v-model="editedItem.canSMS" label="Access to SMS tool"></v-checkbox>
                      </v-form>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
                <v-btn color="blue darken-1" flat @click.native="save" :disabled="!newUserValid">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-spacer></v-spacer>
          <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="users" :search="search" item-key="id" :loading="tableLoading"
          :pagination.sync="pagination">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.Name }}</td>
            <td>{{ props.item.Email }}</td>
            <td>{{ props.item.Role }}</td>
            <td>
              {{
            supplierObj[props.item.Company] === undefined
              ? "-----"
              : supplierObj[props.item.Company].name
          }}
            </td>
            <td class="text-xs-right">
              <v-btn icon class="mx-0" @click.stop="editItem(props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn icon class="mx-0" @click.stop="deleteItem(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { fireStore, createAuth, auth } from "../../firebase";
export default {
  data() {
    return {
      expanded: false,
      emailSending: false,
      newUserValid: false,
      password: "",
      users: [],
      headers: [
        {
          text: "Name",
          value: "Name",
          align: "left",
        },
        {
          text: "Email",
          value: "Email",
          align: "left",
        },
        {
          text: "Role",
          value: "Role",
          align: "left",
        },
        {
          text: "Company",
          value: "Company",
          align: "left",
        },
        {
          text: "Actions",
          value: "Actions",
          align: "right",
          sortable: false,
        },
      ],
      search: "",
      dialog: false,
      editedIndex: -1,
      engineers: [],
      customers: [],
      tableLoading: false,
      editedItem: {
        Name: "",
        Email: "",
        Role: "",
        Company: "",
        Customers: [],
      },
      defaultItem: {
        Name: "",
        Email: "",
        Role: "",
        minInvoiceStatus: 2,
        Company: "",
        Customers: [],
        unassigned: true,
        canSMS: false,
      },
      pagination: {
        sortBy: "Name",
        rowsPerPage: 25,
        page: 1,
        descending: false,
      },
      hasSelectedAllCustomers: false,
      userDeletedSucc: null,
      userDeletedFail: null,
    };
  },
  created() {
    this.tableLoading = true;
    this.$store.dispatch("fetchSuppliers");
    this.$store.dispatch("fetchRoles");
    fireStore
      .collection("Users")
      .get()
      .then((snap) => {
        snap.forEach((doc) => {
          let data = doc.data();
          data.id = doc.id;
          this.users.push(doc.data());
          this.tableLoading = false;
        });
      });

    fireStore
      .collection("Customers")
      .get()
      .then((snap) => {
        snap.forEach((doc) => {
          let data = doc.data();
          data.id = doc.id;
          this.customers.push(data);
        });
      });
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New User" : "Edit User";
    },
    supplierObj() {
      const suppliers = this.$store.getters.suppliers;
      let supplierObj = {};
      suppliers.forEach((supplier) => {
        supplierObj[supplier.key] = { name: supplier.name };
      });
      return supplierObj;
    },
    suppliers() {
      return this.$store.getters.suppliers;
    },
    roles() {
      return this.$store.getters.roles;
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  methods: {
    sendResetEmail() {
      this.emailSending = true;
      createAuth.sendPasswordResetEmail(this.editedItem.Email).then(() => {
        this.emailSending = false;
      });
    },
    editItem(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.unassigned =
        this.editedItem.unassigned === undefined
          ? true
          : this.editedItem.unassigned;
      this.editedItem.canSMS =
        this.editedItem.canSMS === undefined ? false : this.editedItem.canSMS;
      this.supplierSelect = this.editedItem.Supplier;
      this.dialog = true;
    },

    async deleteItem(item) {
      const index = this.users.indexOf(item);
      if (confirm("Are you sure you want to delete this item?")) {
        // Delete the user from firebase authentication database
        await auth.currentUser.getIdToken(true).then(async (idToken) => {
          if (idToken) {
            const response = await fetch(`https://us-central1-engineer-ae17e.cloudfunctions.net/deleteUser/${item.UID}`, {
              method: "DELETE",
              headers: {
                Authorization: `Bearer ${idToken}`,
              }
            })
            if (response.status === 200) {
              fireStore
                .collection("Users")
                .doc(item.UID)
                .delete()
                .then(() => {
                  this.users.splice(index, 1);
                  this.userDeletedSucc = true;
                });
            } else {
              console.log(response);
              this.userDeletedFail = true;
            }
          }
        });

        setTimeout(() => {
          this.userDeletedSucc = null;
          this.userDeletedFail = null;
        }, 3000);
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      console.log(this.editedItem);
      if (this.editedIndex > -1) {
        fireStore
          .collection("Users")
          .doc(this.editedItem.UID)
          .set(this.editedItem, { merge: true })
          .then(() => {
            Object.assign(this.users[this.editedIndex], this.editedItem);
            this.close();
          });
      } else {
        createAuth
          .createUserWithEmailAndPassword(this.editedItem.Email, this.password)
          .then((details) => {
            this.editedItem.UID = details.user.uid;
            fireStore
              .collection("Users")
              .doc(details.user.uid)
              .set(this.editedItem)
              .then(() => {
                this.editedItem.id = details.user.uid;
                this.users.push(this.editedItem);
                this.close();
              });
          });
      }
    },
    selectAllCustomers() {
      console.log(this.hasSelectedAllCustomers);
      if (this.hasSelectedAllCustomers) {
        this.editedItem.Customers = [];
        this.hasSelectedAllCustomers = false;
      } else {
        this.editedItem.Customers = this.customers.map((customer) => {
          return customer.id;
        });
        this.hasSelectedAllCustomers = true;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// User.vue?f8433224